import BaseSelectEditorComponent from './common/BaseSelectEditorComponent';
import { useObjectListOptions } from './JourneyListFilterEditor';
import { CONTACT_CREATE_ATTRIBUTION } from 'reporting-data/constants/dataTypes';
import { fromJS } from 'immutable';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
const LIST_PROPERTY_MAP = {
  CONTACT_CREATE_ATTRIBUTION: 'hs_contact_list_memberships'
};
const getCurrentFilterValue = (report, listProperty) => {
  var _report$getIn$filter$;
  return (_report$getIn$filter$ = report.getIn(['config', 'filters', 'custom']).filter(filter => filter.get('property') === listProperty).first()) === null || _report$getIn$filter$ === void 0 || (_report$getIn$filter$ = _report$getIn$filter$.get('values')) === null || _report$getIn$filter$ === void 0 || (_report$getIn$filter$ = _report$getIn$filter$.map(a => Number(a))) === null || _report$getIn$filter$ === void 0 ? void 0 : _report$getIn$filter$.toJS();
};
const ContactListEditor = ({
  report,
  onChange
}) => {
  const {
    savedOptions,
    loadListOptions
  } = useObjectListOptions('0-1', undefined);
  const listProperty = LIST_PROPERTY_MAP[report.getIn(['config', 'dataType'])];
  const currentFilterValue = getCurrentFilterValue(report, listProperty);
  return /*#__PURE__*/_jsx(BaseSelectEditorComponent, {
    "data-test-id": "contact-list-editor",
    options: savedOptions,
    loadOptions: loadListOptions,
    onChange: ({
      target: {
        value
      }
    }) => {
      const currentCustomFilters = report.getIn(['config', 'filters', 'custom']);
      const updatedCustomFilters = currentCustomFilters.filter(filter => {
        return filter.get('property') !== listProperty;
      }).toList();
      const reportWithUpdatedFilters = report.setIn(['config', 'filters', 'custom'], value.length > 0 ? updatedCustomFilters.push(fromJS({
        property: listProperty,
        operator: 'EQ',
        values: value
      })) : updatedCustomFilters);
      onChange(reportWithUpdatedFilters);
    },
    value: currentFilterValue,
    multi: true,
    tooltipHeader: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "reporting-enablement.reportEditors.contactListEditor.title"
    }),
    placeholder: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "reporting-enablement.reportEditors.contactListEditor.title"
    })
  });
};
ContactListEditor.isUsableForReport = report => {
  return report.getIn(['config', 'dataType']) === CONTACT_CREATE_ATTRIBUTION;
};
ContactListEditor.isFilterEditor = true;
ContactListEditor.displayName = 'ContactListEditor';
export default ContactListEditor;